<template>
  <div class="body">
    <div class="body-box">
      <div class="body-box-left">
        <img class="body-box-left-logo" src="../../assets/logo.png" alt="技考邦" />
        <img class="body-box-left-cover" src="../../assets/login-cover.png" alt="技考邦登录插画" />
      </div>
      <div class="body-box-right">
        <div class="body-box-right-tab">
          <template v-for="(item, index) in tabsData">
            <p class="body-box-right-tab-item" :class="tabsIndex === index ? 'active' : ''" :key="index"
              @click="tabsIndex = index">账号密码登录</p>
          </template>
        </div>
        <div style="height: 48px;"></div>
        <div class="body-box-right-row">
          <input class="body-box-right-row-input" type="text" maxlength="11" v-model="saveForm.phoneNo"
            placeholder="请输入手机号" />
        </div>
        <div class="body-box-right-row" v-if="tabsIndex === 0">
          <input class="body-box-right-row-input" type="password" v-model="saveForm.password" placeholder="请输入密码" />
          <img class="body-box-right-row-icon" src="../../assets/icon-pwd-hide.png" />
        </div>
        <div class="body-box-right-row code" v-if="tabsIndex === 1">
          <input class="body-box-right-row-input" type="text" v-model="saveForm.phoneCode" placeholder="请输入验证码" />
          <button class="code-btn" :disabled="codeDisabled" @click="getCodeFn">{{ codeText }}</button>
        </div>
        <div class="body-box-right-tool" v-if="tabsIndex === 0">
          <el-checkbox class="body-box-right-tool-check" size="medium" v-model="remember">记住手机号及密码</el-checkbox>
          <div class="body-box-right-tool-forget" @click="forgetFn">忘记密码</div>
        </div>
        <button class="body-box-right-login" :disabled="saveDisabled" @click="loginFn">登录</button>
        <div class="body-box-right-desc">
          <a href="/">进入技考邦·练题平台</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../api';
import { regPhone } from '../../utils/util'
export default {
  name: 'login-page',
  data() {
    return {
      tabsData: ['账号密码登录', '短信验证码登录'],
      tabsIndex: 0,
      codeText: '获取验证码',
      codeDisabled: true,
      saveForm: {
        phoneNo: localStorage.getItem('phoneNo') || '',
        password: localStorage.getItem('password') || '',
        phoneCode: ''
      },
      remember: localStorage.getItem('password') ? true : false,
      saveDisabled: false,
      codeInter: null
    }
  },
  watch: {
    'saveForm.phoneNo'(val) {
      this.codeDisabled = !regPhone.test(val) ? true : false;
    },
    tabsIndex(val) {
      if (val === 1) {
        this.codeDisabled = !regPhone.test(this.saveForm.phoneNo) ? true : false;
      }
    }
  },
  mounted() {
    // 清除计时器
    clearInterval(this.codeInter)
    this.codeInter = null;
  },
  methods: {
    // 获取验证码
    getCodeFn() {
      this.codeDisabled = true;
      api.sendPhoneCodeApi({
        phone: this.saveForm.phoneNo
      }).then((res) => {
        if (res.errno === 0) {
          this.downTimeFn()
          return false
        }
        this.codeDisabled = false;
        this.$message.error(res.errmsg)
      }).catch(() => {
        this.codeDisabled = false;
      })
    },
    // 倒计时
    downTimeFn() {
      let t = 60;
      this.codeText = `重新发送（${t}s）`;
      this.codeInter = setInterval(() => {
        if (t < 1) {
          clearInterval(this.codeInter)
          this.codeInter = null;
          this.codeText = '获取验证码';
          this.codeDisabled = !regPhone.test(this.saveForm.phoneNo) ? true : false;
          return false;
        }
        t--;
        this.codeText = `重新发送（${t}s）`;
      }, 1000)
    },
    // 忘记密码
    forgetFn() {
      this.$alert('请联系工作人员：0818-2282222', '系统提示', {
        showClose: false,
        showCancelButton: false
      })
    },
    // 登录
    loginFn() {
      if (this.saveForm.phoneNo === '') {
        this.$message.warning('请输入手机号');
        return false;
      }
      if (this.tabsIndex === 0 && this.saveForm.password === '') {
        this.$message.warning('请输入密码');
        return false;
      }
      if (this.tabsIndex === 1 && this.saveForm.phoneCode === '') {
        this.$message.warning('请输入验证码');
        return false;
      }
      this.saveDisabled = true;
      let _$api = api.loginByPasswordApi;
      // 切换短信验证码登录接口
      if (this.tabsIndex === 1) {
        _$api = api.loginByPhoneCodeApi;
      }
      _$api(this.saveForm).then((res) => {
        setTimeout(() => {
          this.saveDisabled = false;
        }, 1000)
        if (res.errno === 0) {
          // 是否记住手机号，密码
          if (this.remember && this.tabsIndex === 0) {
            localStorage.setItem('phoneNo', this.saveForm.phoneNo)
            localStorage.setItem('password', this.saveForm.password)
          } else {
            localStorage.removeItem('phoneNo')
            localStorage.removeItem('password')
          }
          localStorage.setItem('token', res.result.token)
          this.$router.replace('/')
          return false;
        }
        this.$message.error(res.errmsg)
      }).catch(() => {
        this.saveDisabled = false;
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.body {
  width: 100vw;
  height: 100vh;
  background: url(../../assets/login-bg.jpg) center / cover no-repeat;
  display: grid;
  align-content: center;
  justify-items: center;

  &-box {
    width: 980px;
    height: 592px;
    background: radial-gradient(#FFFFFF, #ECF3FF);
    border-radius: 10px 10px 10px 10px;
    box-shadow: 16px 0px 35px 0px rgb(67, 125, 239, .1);
    display: flex;

    &-left {
      width: 438px;
      margin-right: 24px;

      &-logo {
        margin: 45px 0 0 39px;
        width: 138px;
        height: 33px;
      }

      &-cover {
        width: 404px;
        height: 343px;
        margin: 59px 0 0 34px;
      }
    }

    &-right {
      flex: 1 0;
      margin-right: 52px;
      overflow: hidden;

      &-tab {
        width: 466px;
        padding-top: 72px;
        display: flex;
        justify-content: space-around;

        &-item {
          font-size: 21px;
          line-height: 21px;
          cursor: pointer;

          &.active {
            font-weight: bold;
            color: #2C68E8;
          }
        }
      }

      &-row {
        height: 71px;
        background: #FFFFFF;
        border-radius: 10px 10px 10px 10px;
        border: 1px solid #E5E5E5;
        margin-bottom: 28px;
        position: relative;

        &-input {
          border: 0;
          width: 100%;
          height: 100%;
          padding: 0 27px;
          font-size: 21px;

          &::placeholder {
            color: #ABABAB;
          }
        }

        &-icon {
          width: 23px;
          position: absolute;
          top: 50%;
          right: 28px;
          transform: translateY(-50%);
          cursor: pointer;
        }

        &.code {
          display: flex;
          align-items: center;

          .code-btn {
            padding: 0 17px;
            height: 69px;
            line-height: 69px;
            font-size: 21px;
            background-color: transparent;
            color: #2C68E8;
            white-space: nowrap;

            &:disabled {
              color: #CCCCCC;
              cursor: no-drop;
            }
          }
        }
      }

      &-tool {
        display: flex;
        align-items: center;
        justify-content: space-between;

        &-check {
          padding-left: 4px;
          display: flex;
          align-items: flex-end;
        }

        &-forget {
          font-size: 18px;
          line-height: 18px;
          color: #2C68E8;
          cursor: pointer;
        }
      }

      &-login {
        width: 100%;
        margin-top: 40px;
        height: 70px;
        background: #2C68E8;
        border-radius: 10px 10px 10px 10px;
        font-size: 32px;
        color: #FFFFFF;
      }

      &-desc {
        margin-top: 25px;
        text-align: center;
        font-size: 21px;
        color: #ABABAB;
      }
    }
  }
}
</style>

<style>
.body-box-right-tool-check .el-checkbox__label {
  font-size: 18px;
  color: #000000 !important;
  font-weight: normal;
}

.body-box-right-tool-check .el-checkbox__inner {
  transform: scale(1.4);
}
</style>